var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaterials(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7832 5.35373C11.0151 5.35373 11.2031 5.16573 11.2031 4.93382C11.2031 4.70191 11.0151 4.51392 10.7832 4.51392C10.5513 4.51392 10.3633 4.70191 10.3633 4.93382C10.3633 5.16573 10.5513 5.35373 10.7832 5.35373Z",
    strokeWidth: 1.39003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1426 8.71298C14.3745 8.71298 14.5625 8.52498 14.5625 8.29307C14.5625 8.06117 14.3745 7.87317 14.1426 7.87317C13.9107 7.87317 13.7227 8.06117 13.7227 8.29307C13.7227 8.52498 13.9107 8.71298 14.1426 8.71298Z",
    strokeWidth: 1.39003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58421 6.19357C6.81612 6.19357 7.00412 6.00557 7.00412 5.77366C7.00412 5.54176 6.81612 5.35376 6.58421 5.35376C6.3523 5.35376 6.16431 5.54176 6.16431 5.77366C6.16431 6.00557 6.3523 6.19357 6.58421 6.19357Z",
    strokeWidth: 1.39003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90452 10.3927C5.13643 10.3927 5.32443 10.2047 5.32443 9.97276C5.32443 9.74085 5.13643 9.55286 4.90452 9.55286C4.67262 9.55286 4.48462 9.74085 4.48462 9.97276C4.48462 10.2047 4.67262 10.3927 4.90452 10.3927Z",
    strokeWidth: 1.39003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52358 1.15479C4.90463 1.15479 1.12549 4.93393 1.12549 9.55288C1.12549 14.1718 4.90463 17.951 9.52358 17.951C10.3012 17.951 10.9076 17.3245 10.9076 16.5334C10.9076 16.1664 10.7564 15.8321 10.5406 15.5886C10.297 15.3459 10.1728 15.041 10.1728 14.6438C10.1696 14.459 10.2036 14.2754 10.2729 14.104C10.3422 13.9326 10.4452 13.7769 10.5759 13.6462C10.7067 13.5155 10.8624 13.4124 11.0337 13.3431C11.2051 13.2739 11.3887 13.2398 11.5736 13.243H13.2498C15.8121 13.243 17.915 11.141 17.915 8.5787C17.8923 4.5241 14.1098 1.15479 9.52358 1.15479Z",
    strokeWidth: 2.08504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterials);
export default __webpack_public_path__ + "static/media/materials.6a3d8e1127cf3bfcc916e50f1d826916.svg";
export { ForwardRef as ReactComponent };